import * as apiClient from '../../services/api-client';

export const search = async (store, params={}, panel=false) => {
    /*
    $defaults = [
        'pg' => 1,
        'limit' => 30,
        'gender' => null,
        'age' => null,
        'price_low' => 0,
        'price_high' => 999999,
        'amazon'=>false
    ];
    */
    const responseData = await apiClient.giftideas.searchGiftIdeas(params, store.state.auth.cla_token);
    
    const response = {
        type: "searchgiftideas",
        data: responseData
    };
    store.setState({ response });
    
    if(!params.pg || params.pg ===1) {
        if(panel) {
            const sidepanelgiftideas = responseData;
            store.setState({ sidepanelgiftideas });
        } else {
            const giftideas = responseData;
            store.setState({ giftideas });
        }
    } else {
        if(panel) {
            const sidepanelgiftideas = [
                ...store.state.sidepanelgiftideas,
                ...responseData
            ];
            store.setState({ sidepanelgiftideas });
        } else {
            const giftideas = [
                ...store.state.giftideas,
                ...responseData
            ];
            store.setState({ giftideas });
        }
        
    }
    
    
};

export const searchAmazon = async (store, params) => {
    params.merchant = 'amazon';
    const responseData = await apiClient.giftideas.searchAmazon(params, store.state.auth.cla_token);
    const response = {
        type: "searchamazon",
        data: responseData
    };
    store.setState({ response });
}

export const addGiftIdea = async (store, data) => {
    const responseData = await apiClient.giftideas.addGiftIdea(data, store.state.auth.cla_token);
    if(data.user_id === store.state.user.userID) {
        let mygiftlist = [
            ...store.state.mygiftlist,
            responseData
        ];
        store.setState({ mygiftlist });
    } else {
        let activeGiftlist = {
            ...store.state.activeGiftlist,
            giftlist: [
                ...store.state.activeGiftlist.giftlist,
                responseData
            ]
        };
        store.setState({ activeGiftlist });
    }
    const response = {
        type: "addgiftidea",
        data: responseData
    };
    store.setState({ response });
}

export const getGiftIdea = async (store, giftIdeaId) => {
    const giftidea = await apiClient.giftideas.getGiftIdea(giftIdeaId, store.state.auth.cla_token);
    store.setState({ giftidea });
}

